import { isValidLatin, isValidUnicodePropertyName } from '../../../../middleware/validation/rules';
import { includePropertyName } from '../../../../utils/UnicodeUtil';

// `isValidLatin` is the same rule the server uses via UnicodeUtil.hasUnicode, so a
// name classified as unicode here is classified as unicode by the LPS payload too.
export const isPropertyNameUnicode = (pName) => isValidUnicodePropertyName.validate(pName)
    && !isValidLatin.validate(pName);

export const isShowingLatinPropertyName = ({ locale, isAAP = false }) => (
    isAAP || includePropertyName(locale) === true
);

/**
 * Single source of truth for "is the property name usable?", shared by the
 * property-info step that collects it and the lead form that is gated on it.
 *
 * The shape below mirrors the fields PropertyDetails actually renders:
 *
 * - When the latin name is NOT shown (every non-CJK, non-AAP locale) the latin
 *   input is rendered as the ONLY property-name field, so setLatinPropertyName
 *   is what fires and latinPropertyNameValidation is the only validation that
 *   gets populated - propertyName stays empty. Gating this case on
 *   propertyNameValidation is what made the lead form permanently invalid.
 * - When the latin name IS shown the unicode input is the primary field, and
 *   the latin input is an additional field required only for a unicode name.
 */
export const isPropertyNameValid = ({
    locale,
    isAAP = false,
    propertyName,
    latinPropertyName,
    propertyNameValidation,
    latinPropertyNameValidation
}) => {
    if (!isShowingLatinPropertyName({ locale, isAAP })) {
        return !!latinPropertyNameValidation?.isValid;
    }

    if (isPropertyNameUnicode(propertyName)) {
        return !!(propertyNameValidation?.isValid && latinPropertyNameValidation?.isValid);
    }

    const latinNameOk = !latinPropertyName || !!latinPropertyNameValidation?.isValid;
    return !!(propertyNameValidation?.isValid && latinNameOk);
};

export default {
    isPropertyNameUnicode,
    isShowingLatinPropertyName,
    isPropertyNameValid
};
